import React from 'react';
import type { BBCommonProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';

const LottieComponent = React.lazy(() => import('./LottieComponent'));

const Lottie: React.FC<BBCommonProps> = props => {
	return (
		<React.Suspense fallback={null}>
			<LottieComponent {...props} />
		</React.Suspense>
	);
};
export default withCardTransitionContext(Lottie);
